export default __webpack_public_path__ + "static/media/42.2f64e1c0.jpg";